import { render } from "./AciasDetail.vue?vue&type=template&id=57b7f7ce&scoped=true"
import script from "./AciasDetail.vue?vue&type=script&lang=js"
export * from "./AciasDetail.vue?vue&type=script&lang=js"

import "./AciasDetail.vue?vue&type=style&index=0&id=57b7f7ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b7f7ce"]])

export default __exports__